var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('div',{ref:"mobileHeaderAlternative",staticClass:"contents"},[_vm._t("mobileHeaderAlternative")],2),_c('div',{ref:"mobileHeaderAppend",staticClass:"contents"},[_vm._t("mobileHeaderAppend")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }